import { WINDOW_FLUTTER_PROP_NAME } from '@/flutter/constants/windowFlutterPropName.js'

const getPanelIsEmbedInFlutter = () => {
  return !!window[WINDOW_FLUTTER_PROP_NAME]
}

export default getPanelIsEmbedInFlutter
